/**
 * @generated SignedSource<<924a1724830bde4a0d657e5e8135325a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type templateAuthorContentfulRelayFragment$data = {
  readonly contributor: {
    readonly __typename: "Author";
    readonly authorNameExternal: string | null | undefined;
    readonly jobTitle: string | null | undefined;
    readonly organization: {
      readonly organizationNameExternal: string | null | undefined;
    } | null | undefined;
  } | {
    readonly __typename: "CompanyNameInternal";
    readonly organizationNameExternal: string | null | undefined;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null | undefined;
  readonly " $fragmentType": "templateAuthorContentfulRelayFragment";
};
export type templateAuthorContentfulRelayFragment$key = {
  readonly " $data"?: templateAuthorContentfulRelayFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"templateAuthorContentfulRelayFragment">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "organizationNameExternal",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "templateAuthorContentfulRelayFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "contributor",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__typename",
          "storageKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "authorNameExternal",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "jobTitle",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "CompanyNameInternal",
              "kind": "LinkedField",
              "name": "organization",
              "plural": false,
              "selections": (v0/*: any*/),
              "storageKey": null
            }
          ],
          "type": "Author",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v0/*: any*/),
          "type": "CompanyNameInternal",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ProductTemplate",
  "abstractKey": null
};
})();

(node as any).hash = "f1d1931be967bc795ac40098c74ecc54";

export default node;
